import { motion } from "framer-motion";
import { Award, Star, FileCheck2, ShieldCheck } from "lucide-react";

const ITEMS = [
  { icon: Award, label: "20 años de experiencia" },
  { icon: Star, label: "5,0 ★ en Google" },
  { icon: FileCheck2, label: "Presupuesto gratuito" },
  { icon: ShieldCheck, label: "Garantía en todos los trabajos" },
];

export const TrustBar = () => (
  <section className="bg-white border-b border-border" data-testid="trust-bar">
    <div className="max-w-7xl mx-auto px-6 lg:px-10">
      <div className="grid grid-cols-2 lg:grid-cols-4 divide-x divide-border">
        {ITEMS.map((it, i) => {
          const Icon = it.icon;
          return (
            <motion.div
              key={i}
              initial={{ opacity: 0, y: 12 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.4, delay: i * 0.08 }}
              className="flex items-center gap-3 justify-center py-6 px-3 text-center"
            >
              <Icon size={20} className="text-electric shrink-0" />
              <span className="font-heading font-semibold text-ink text-sm sm:text-base">{it.label}</span>
            </motion.div>
          );
        })}
      </div>
    </div>
  </section>
);
